import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetUnderscoreLocale } from './recommendationAccessorGetUnderscoreLocale'

export const recommendationAccessorGetLocalizedProductImageUrl = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productImageUrl =
    product[`image_url_${recommendationAccessorGetUnderscoreLocale(locale)}`]

  if (!productImageUrl) {
    return ''
  }

  return productImageUrl
}
